import React, { useEffect, useMemo, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import Breadcrumbs from "../../components/Common/Breadcrumb";
import TableContainerCustom from "../../components/Common/TableContainerCustom";
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { useBrochureCols } from "./BrochureListMemo";
import { withTranslation } from "react-i18next";
import { getBrochureList, modalAreaShow } from "../../store/actions";


const BrochureList = (props) => {
    const dispatch = useDispatch();

    const { brochureList = [], totalItems = 0 } = useSelector(state => ({
        brochureList: state.ReportsReducer.brochureList || [],
        totalItems: state.ReportsReducer.totalItems || 0
    }));

    const memoBrochureCols = useBrochureCols();

    /**
     * @param {*} pagination
     *
     */
    const [pagination, setPagination] = useState({
        page: 1,
        pageSize: 10,
        active: true,
        for_: 'inventory',
        total: 0,
        search: {
            filter: null
        }
    });

    const handlePageChange = (newPage, search) => {
        setPagination(prev => ({
            ...prev,
            page: newPage,
            search: search || prev.search
        }));
    };

    const handleGetBrochureList = () => {
        dispatch(getBrochureList(pagination));
    };

    useEffect(() => {
        //handleGetBrochureList();
    }, []);

    useEffect(() => {
       handleGetBrochureList();
    }, [pagination.page, pagination.pageSize, pagination.search]);

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumbs
                        title={props.t("Lista de Brochures")}
                        breadcrumbItem={props.t("Listado")}
                    />
                    <Row>
                        <Col xs="12">
                            <Card>
                                <CardBody>
                                    <TableContainerCustom
                                        className="" addBtnNewFlag={false} 
                                        lblBtnAddNew = "" 
                                        handleAddNewClick={{}}
                                        data={brochureList}
                                        isGlobalFilter={false}
                                        isAddOptions={false} serverSidePagination={{
                                            totalItems: totalItems,
                                            currentPage: pagination?.page,
                                            onPageChange: handlePageChange,
                                            search: pagination?.search
                                        }} customPageSize={pagination?.pageSize}
                                        columns={memoBrochureCols} />
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
        </React.Fragment>
    )

}
export default withTranslation()(BrochureList);
//export default AreaList;